import { visitInfo } from '../api';
import { globalInstance } from '@kk-activity-factory/utils';
import Bus, { busEvent } from '@kk-activity-factory/bus';
import types from './types';
import priorityProcessing from '@kk-activity-factory/priority-processing';

export default {
    async uploadPV({ commit, state }, data = {}) {
        try {
            const { data } = await visitInfo();
            globalInstance.getRootVue().kksaTrack('ActivityPV', {
                IsFirsttime: data.firstVisit,
                ActivityName: state.pageData?.name || '',
                xdevice: '',
                ...data,
            });
            commit(types.SET_PV_STATUS, {
                hasUploadPV: true,
                isFirstTime: data.firstVisit,
                isCurrentDayFirstVisit: data.currentDayFirstVisit,
                userAvatar: data.userAvatar,
            });
            Bus.$emit(busEvent.CAN_GET_VISIT_PRIZE); // 通知下奖励
            if (!state.priorityProcessingStart) {
                commit(types.SET_PRIORITY_PROCESSING_START);
                priorityProcessing.start(globalInstance.getRootStore().getters.displayList);
            }
        } catch (error) {
            globalInstance.getRootVue().kksaTrack('ActivityPV', { ...data }); // 上报缺少IsFirsttime的PV埋点
            commit(types.SET_PV_STATUS, {
                hasUploadPV: true,
                isFirstTime: false,
                isCurrentDayFirstVisit: false,
            });
            console.error('uploadPVData', error);
            if (!state.priorityProcessingStart) {
                commit(types.SET_PRIORITY_PROCESSING_START);
                priorityProcessing.start(globalInstance.getRootStore().getters.displayList);
            }
        }
    },
};
